import { DateTime } from 'luxon'

import { SubscriptionItemResponseDTO } from '@core/api/dtos/response/accounts/subscriptionItem'
import { SubscriptionItem } from '@core/api/entities/account/subscriptionItem'

export class SubscriptionItemMapper {
	static toEntity(dto: SubscriptionItemResponseDTO): SubscriptionItem {
		return SubscriptionItem.create({
			id: dto.id,
			subscriptionId: dto.subscription_id,
			productId: dto.product_id,
			quantity: dto.quantity,
			amount: dto.amount,
			discount: dto.discount,
			createdAt: dto.created_at ? DateTime.fromISO(dto.created_at) : undefined,
			updatedAt: dto.updated_at ? DateTime.fromISO(dto.updated_at) : undefined,
		})
	}

	static toEntities(dtos: SubscriptionItemResponseDTO[]): SubscriptionItem[] {
		return dtos.map(this.toEntity)
	}
}
